import { render, staticRenderFns } from "./GetAllBlogs.vue?vue&type=template&id=3b660936&"
import script from "./GetAllBlogs.vue?vue&type=script&lang=js&"
export * from "./GetAllBlogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports